import './index.less';
import Everlane from './everlane.svg';
import Frida from './frida.svg';
import HonestCompany from './honest-co.svg';
import Houseplant from './houseplant.svg';
import Rhode from './rhode.svg';
import Vacation from './vacation.svg';

export default function NewBrandLogos() {
  return (
    <div className="new-brand-logos">
      <div className="desc">300,000+ businesses choose Pietra like:</div>
      <div className="logo">
        <Rhode />
        <Everlane />
        <HonestCompany />
        <Houseplant />
        <Frida />
        <Vacation />
      </div>
    </div>
  );
}
